import * as React from 'react';
import * as styles from './InteractiveElementsWrapper.css';
import { clsx } from 'clsx';

interface IInteractiveElementsWrapperProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: React.ReactNode;
}

export const InteractiveElementsWrapper: React.FC<IInteractiveElementsWrapperProps> = ({
  children,
  className,
  onClick,
  ...restDivProps
}) => {
  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();

      onClick?.(e);
    },
    [onClick],
  );

  return (
    <div className={clsx(styles['wrapper'], className)} {...restDivProps} onClick={handleClick}>
      {children}
    </div>
  );
};
